import { REPORT_TYPE_OPTIONS } from './constants';

import { Checkbox } from '@/components/ui/checkbox';
import { Field, FieldLabel } from '@/components/ui/field';

interface ReportTypeSelectProps {
  onValueChange: (value: string[]) => void;
  value: string[];
}

const ReportTypeSelect = ({ onValueChange, value }: ReportTypeSelectProps) => {
  const toggleCode = (code: string) => {
    const next = value.includes(code)
      ? value.filter(c => c !== code)
      : [...value, code].sort();
    onValueChange(next);
  };

  return (
    <Field>
      <FieldLabel className="inline-block">
        Report Types <span className="text-red-500">*</span>
      </FieldLabel>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {REPORT_TYPE_OPTIONS.map(opt => (
          <label
            className="flex cursor-pointer items-center gap-2"
            key={opt.value}
          >
            <Checkbox
              checked={value.includes(opt.value)}
              onCheckedChange={() => {
                toggleCode(opt.value);
              }}
            />
            <span className="text-sm">{opt.name}</span>
          </label>
        ))}
      </div>
    </Field>
  );
};

export default ReportTypeSelect;
